import { render } from "./BusinessProtectionExpressQuestion.vue?vue&type=template&id=eb58a90a&scoped=true"
import script from "./BusinessProtectionExpressQuestion.vue?vue&type=script&lang=js"
export * from "./BusinessProtectionExpressQuestion.vue?vue&type=script&lang=js"

import "./BusinessProtectionExpressQuestion.vue?vue&type=style&index=0&id=eb58a90a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb58a90a"]])

export default __exports__